import { AppWidgetSummary } from '../components/dashboard/AppWidgetSummary';
import { Box, Divider, Typography, Grid } from '@mui/material';
import { useHasPermission } from '../hooks/useHasPermission';
import { useEffect, useState, useCallback } from 'react';
import Page from '../components/Page';
import axios from 'axios';

export const DashboardApp = () => {

  const hasReadUsersPermission = useHasPermission('user_view');

  const [counts, setCounts] = useState([]);

  const handleFetchAppWidgetCounts = useCallback(async () => {
    try {
      const { data, status } = await axios.get('dashboard/appWidgetCounts');
      if (status === 200 || status === 201) {
        setCounts(data || []);
      }
    } catch (error) {
      console.error('Error Fetch App Widget Counts :', error.message);
    }
  }, []);

  useEffect(() => {
    handleFetchAppWidgetCounts();
  }, [handleFetchAppWidgetCounts]);

  const groupedCounts = {
    main: counts?.slice(hasReadUsersPermission ? 0 : 1, 4) || [],
    localisation: counts?.slice(4, 8) || [],
    // configuration: counts?.slice(8) || []
  };

  const renderSection = (title, items) => (
    <>
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 1 }}>
          <Typography sx={{ fontSize: '15px', fontWeight: 600, fontFamily: 'Mulish', color: '#CD5C5C' }}>{title}</Typography>
          <Divider sx={{ flexGrow: 1, ml: 2, borderColor: '#CD5C5C' }} />
        </Box>
      </Grid>
      {items?.map((count) => (
        <Grid item xs={12} sm={6} md={3} key={count?.title}>
          <AppWidgetSummary
            title={count?.title || ''}
            total={count?.total || 0}
            icon={count?.icon || ''}
          />
        </Grid>
      ))}
    </>
  );

  return (
    <Page title="Tableau de bord">
      <Box className="dashboard-widgetSummary-container">
        <Grid container spacing={2}>
          {renderSection("Principal", groupedCounts.main)}
          {renderSection("Localisation", groupedCounts.localisation)}
          {/* {renderSection("Configuration", groupedCounts.configuration)} */}
        </Grid>
      </Box>
    </Page>
  );
};